import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import { notify } from "../../utils/notify";
import isEmail from "../../utils/isEmail";
import validationPasswordCognito from "../../utils/validationPasswordCognito";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import Header from "../../components/header/Header";
import validatesNotNull from "../../utils/validatesNotNull";
import {
  userCodeRecover,
  userPasswordChange,
} from "../../repositories/userRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";

const RecoverPassword = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [formVerificationCode, setFormVerificationCode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeRec, setCodeRec] = useState(false);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [showNewPass, setShowNewPass] = useState(false);
  const [showRepeatPass, setShowRepeatPass] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSendCode = async () => {
    try {
      if (!isEmail(email)) {
        setErrors({ email: true });
        return notify("Digite um e-mail válido.", true, "error");
      }

      setLoading(true);

      const result = await userCodeRecover({ email });

      if (result) {
        notify(
          "Um código de verificação foi enviado no e-mail informado.",
          false,
          "info"
        );

        setFormVerificationCode(true);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleUpdatePassword = async () => {
    try {
      setLoading(true);
      let validationFail = false;

      const resultValidation = validatesNotNull([
        { value: password, key: "password" },
        { value: repeatPassword, key: "repeatPassword" },
        { value: codeRec, key: "codeRec" },
      ]);

      let passValidation = validationPasswordCognito(password);

      if (
        !passValidation.uperCase ||
        !passValidation.lowerCase ||
        !passValidation.number ||
        password.length < 8
      ) {
        validationFail = true;
        resultValidation.errorsValidation.password = true;
        resultValidation.errorsValidation.repeatPassword = true;
        notify(
          "A senha deve ter letras maiúsculas, minúsculas, números e no minimo 8 caracteres."
        );
      }

      if (password !== repeatPassword) {
        validationFail = true;
        resultValidation.errorsValidation.password = true;
        resultValidation.errorsValidation.repeatPassword = true;
        notify("As senhas não coincidem.", false, "error");
      }

      if (resultValidation.error || validationFail) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      } else {
        setErrors({});
      }

      const result = await userPasswordChange({ email, password, codeRec });

      if (result) {
        notify("Senha alterada com sucesso.", false, "info");
        history.push("/login");
      }
      setLoading(false);
    } catch (error) {
      console.error("ERROR: RecoverPassword", error);
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <ModalLoading loading={loading} />}
      <Header />
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
        style={{ marginTop: 90 }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={5}
          md={7}
          sm={8}
          xs={10}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={history.goBack} />
          <label className="title">Recuperar senha</label>

          {formVerificationCode ? (
            <>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextFieldCustom
                  label="Código de verificação*"
                  autoFocus
                  type="number"
                  value={codeRec}
                  setValue={setCodeRec}
                  error={errors.codeRec}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextFieldCustom
                  label="Nova senha*"
                  type={showNewPass ? "text" : "password"}
                  value={password}
                  setValue={setPassword}
                  error={errors.password}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        className="eyePasswordIcon"
                        aria-label="toggle password visibility"
                        onClick={() => setShowNewPass(!showNewPass)}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {showNewPass ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    ),
                  }}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextFieldCustom
                  label="Repita a senha*"
                  type={showRepeatPass ? "text" : "password"}
                  value={repeatPassword}
                  setValue={setRepeatPassword}
                  error={errors.repeatPassword}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        className="eyePasswordIcon"
                        aria-label="toggle password visibility"
                        onClick={() => setShowRepeatPass(!showRepeatPass)}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {showRepeatPass ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    ),
                  }}
                />
              </Grid>

              <button
                type="button"
                id="buttonStyle"
                className="btn btn-info btn-block"
                onClick={handleUpdatePassword}
              >
                Alterar senha
              </button>
            </>
          ) : (
            <>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextFieldCustom
                  label="E-mail*"
                  autoFocus
                  type="text"
                  value={email}
                  setValue={setEmail}
                  error={errors.email}
                />
              </Grid>

              <button
                type="button"
                id="buttonStyle"
                className="btn btn-info btn-block"
                onClick={handleSendCode}
              >
                Enviar
              </button>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default RecoverPassword;
